/**
 * @Injectable
 * All services for search storing
 *
 */

import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';
import { Document } from '../models/document.model';
import { HttpService } from './http.service';


@Injectable()

export class StoreService {

  loaded: boolean = false;
  quantity: number = 4;
  rank: number = 0;
  results: Document[] = [];

  resultsUpdate: EventEmitter<any> = new EventEmitter();

  sort_rules = {
      1: 1,
      2: 2,
      14: 3,
      34: 4,
      35: 5,
      36: 5,
      37: 5,
      38: 5,
      39: 5,
      40: 5,
      41: 5
  };

  constructor(
    private http: HttpService,
    private router: Router
  ) { 
      console.log(this.sort_rules[34]);
  }


  /**
   * Set current store results
   *
   * @param 		{Object}       containing sent form
   * @return		{Promise}      void
   */
  setResults(form: any): Promise<void> {
    this.loaded = true;
    return this.http.post(environment.apiUrl + 'document/search', form)
               .toPromise()
               .then(documents => {
                   var json = documents.json()
                   console.log(json);
                   this.results = this.sort(json, this.sort_rules);
                 this.rank = 0;
                 this.router.navigate(['/results']);
                 this.resultsUpdate.emit(this.getResults());
               });
  }

  /**
   * Get current store results
   *
   * @return		{Object}      with an object that return current store status and results
   */
  getResults(): any {
    return {
      results: this.results,
      loaded: this.loaded,
      rank: this.rank,
      quantity: this.quantity
    };
  }

  /**
   * Set current store rank
   *
   * @return		{Number}     new rank
   * @return		{void}
   */
  setRank(rank: number): void {
    this.rank = rank;
  }

  /**
   * Set current store quantity
   *
   * @return		{Number}     new quantity
   * @return		{void}
   */
  setQuantity(quantity: number): void {
    this.quantity = quantity;
  }

  /**
   * Sort order (ADAPEI given rules eg. see sort_rules tab)
   *
   * @param json  {JSON}
   * @param tab   {Object}
   *
   * @returns sorted {json}
   */
  sort(json: Document[], tab: Object): Document[] {
      let json_sorted = json.sort(function (a, b) {
          let va;
          let vb;
          console.log(a, b);

          // get priority val in tab_rules and if not defined assign 10 to order
          if (tab[a.domain_id] == undefined)
              va = 10;
          else
              va = tab[a.domain_id];

          if (tab[b.domain_id] == undefined)
              vb = 10;
          else
              vb = tab[b.domain_id];

          
          if (va < vb)
              return -1;
          if (va > vb)
              return 1
          return 0
      });

      return json_sorted;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/store.service.ts